import { Alert } from "@/redux/message/messageSlice";
import { t } from "@repo/shared/i18n";

/**
 * Shown when the extension reports `clubClaimBlocked` (ADR 0012): the club is
 * already linked to another EasySBC account, so the import was rejected and
 * nothing changed — neither the club nor the user's own players.
 *
 * The holder can unlink it from its own profile (ADR 0030), so the copy points
 * there. Placeholder treatment — a plain red alert — until this gets a designed
 * state. A function, not a constant: the copy is translated when the alert is
 * raised, after i18n init.
 */
export const clubClaimBlockedAlert = (): Omit<Alert, "id"> => ({
  type: "error",
  title: t("clubImport:alerts.claimBlocked.title"),
  description: t("clubImport:alerts.claimBlocked.description"),
  persistent: true,
});
